import { logUsage } from 'owa-analytics';
import getFolderViewStateFromId from 'owa-mail-folder-store/lib/selectors/getFolderViewStateFromId';

/**
 * Logs the root folder click and its current expansion state.
 * @param distinguishedFolderId
 */
export default function logRootFolderNodeClick(distinguishedFolderId: string) {
    const localViewState = getFolderViewStateFromId(distinguishedFolderId);
    logUsage('Triage_ToggleFolderExpansion', [distinguishedFolderId, localViewState.isExpanded]);
}
